import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Запрет масштабирования страницы (pinch/двойной тап) — как в приложении.
// Скролл и все тапы работают как обычно; iOS игнорирует user-scalable=no,
// поэтому гасим жесты отдельно.
["gesturestart", "gesturechange", "gestureend"].forEach((ev) => {
  document.addEventListener(ev, (e) => e.preventDefault(), { passive: false });
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// Статичный бут-сплэш из index.html: снимаем после первого кадра React,
// чтобы не было вспышки непрогруженного приложения до появления сплэша.
requestAnimationFrame(() => {
  requestAnimationFrame(() => document.getElementById("boot-splash")?.remove());
});
